import React, { ReactElement } from 'react';
import { FormHorizontal } from '~/components/form/layout';
import { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import { PersonaType } from '~/tenants/common/TenantPersona';
import ZodFieldCards from '~/components/zod/ZodFieldCards';
import FormGroup from '~/components/form/FormGroup';
import { useZodFormFieldSingleValue } from '~/components/zod/ZodForm';
import McmDroneJob from '~/tenants/mcm/performable/drone/McmDroneJob';

export default function McmDroneForm({ context, persona }: TenantPerformableFormProps<McmOrderContext>): ReactElement {
  const typeOptions = [
    { title: 'Photo', value: McmDroneType.PHOTO, cost: McmDroneJob.cost(context, McmDroneType.PHOTO).both },
    {
      title: 'Video (Limited)',
      value: McmDroneType.VIDEO_LIMITED,
      hidden: persona === PersonaType.CUSTOMER,
      cost: McmDroneJob.cost(context, McmDroneType.VIDEO_LIMITED).both,
    },
    {
      title: 'Video (Full)',
      value: McmDroneType.VIDEO_FULL,
      hidden: persona === PersonaType.CUSTOMER,
      cost: McmDroneJob.cost(context, McmDroneType.VIDEO_FULL).both,
    },
    {
      title: 'Video + Photo',
      value: McmDroneType.VIDEO_PHOTO,
      cost: McmDroneJob.cost(context, McmDroneType.VIDEO_PHOTO).both,
    },
  ];

  const type = useZodFormFieldSingleValue<McmDroneType>('type') ?? McmDroneType.PHOTO;

  return (
    <FormGroup>
      <FormHorizontal name="type" label="Drone Type">
        <ZodFieldCards name="type" options={typeOptions} />
      </FormHorizontal>
      <FormHorizontal name="twilight" label="Time of Day">
        <ZodFieldCards
          name="twilight"
          options={[
            {
              title: 'Daytime',
              value: 'false',
              cost: 0,
            },
            {
              title: 'Twilight',
              value: 'true',
              cost: McmDroneJob.cost(context, type).twilight,
              disabled: type === McmDroneType.VIDEO_LIMITED,
            },
          ]}
        />
      </FormHorizontal>
    </FormGroup>
  );
}
